import { Link } from "react-router-dom";
import { Facebook, MessageCircle, Instagram, Youtube, Mail, Phone } from "lucide-react";
import { useSettings } from "@/lib/providers";
import { waLink } from "@/lib/api";
import { Logo } from "./Navbar";

export const WhatsAppFab = () => {
  const { settings } = useSettings();
  if (!settings.whatsapp_number) return null;
  return (
    <a href={waLink(settings.whatsapp_number)} target="_blank" rel="noreferrer" data-testid="whatsapp-fab"
      className="fixed bottom-5 left-5 z-40 btn-pop btn-primary grid place-items-center w-14 h-14 rounded-full"
      aria-label="تواصل عبر واتساب">
      <MessageCircle size={26} />
    </a>
  );
};

export default function Footer() {
  const { settings: s } = useSettings();
  const socials = [
    [s.facebook_url, Facebook, "footer-facebook-link", "فيسبوك"],
    [s.instagram_url, Instagram, "footer-instagram-link", "إنستجرام"],
    [s.youtube_url, Youtube, "footer-youtube-link", "يوتيوب"],
    [s.whatsapp_number && waLink(s.whatsapp_number), MessageCircle, "footer-whatsapp-link", "واتساب"],
  ].filter(([u]) => u);
  return (
    <footer className="relative bg-[var(--kh-deep)] text-white mt-24 border-t-2 border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <Logo onDark />
          <p className="text-white/80 max-w-md text-sm leading-relaxed">
            أكاديمية عربية لتعليم الموشن جرافيك والأنيميشن بكورسات مسجلة، تتفرج عليها في أي وقت ومن أي مكان.
          </p>
          <div className="flex gap-2">
            {socials.map(([u, Icon, id, label]) => (
              <a key={id} href={u} target="_blank" rel="noreferrer" data-testid={id} aria-label={label}
                className="grid place-items-center w-10 h-10 rounded-full bg-white/15 hover:bg-[#FFFFFF] hover:text-[var(--kh-violet)] transition-colors"><Icon size={18} /></a>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-heading font-bold mb-4">روابط</h3>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/courses" className="hover:text-white">الكورسات</Link></li>
            <li><Link to="/about" className="hover:text-white">عن الأكاديمية</Link></li>
            <li><Link to="/faq" className="hover:text-white">الأسئلة الشائعة</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">سياسة الخصوصية</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">الشروط والأحكام</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-heading font-bold mb-4">تواصل</h3>
          <ul className="space-y-3 text-sm text-white/80">
            {s.contact_phone && <li className="flex items-center gap-2"><Phone size={15} /><span dir="ltr">{s.contact_phone}</span></li>}
            {s.contact_email && <li className="flex items-center gap-2"><Mail size={15} />{s.contact_email}</li>}
            <li><Link to="/contact" className="text-white font-semibold hover:opacity-80">صفحة التواصل ←</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15 py-5 text-center text-xs text-white/60">
        © {new Date().getFullYear()} أكاديمية خرابيش — Kharabeesh Academy. جميع الحقوق محفوظة.
      </div>
    </footer>
  );
}
